export const FormTag = ({ children, className = "" }) => (
  <p className={"font-poppins text-base font-semibold mb-3 " + className}>{children}</p>
);
